import dayjs from 'dayjs'

import { usePaymentContext } from '../components/subscription/context/payment-context'
import { type ServiceType } from '../types/GeneralStateType'
import { type UserSubscriptionType } from '../types/SubscriptionType'
import { type TherapistType } from '../types/TherapistStateType'
import { dateToMonthYear } from '../utilities/date'
import useSubscription from './useSubscription/useSubscription'

export const getIsSubscribedTherapistAndService = (
  therapist: TherapistType,
  service: ServiceType,
  subscription: UserSubscriptionType,
) => {
  return Boolean(
    therapist &&
      subscription &&
      therapist.therapistId === subscription.therapistId &&
      service.id === subscription.serviceId,
  )
}

export const useHasValidSubscription = (startDate) => {
  const { getSubscription, activeSubscription } = useSubscription()
  const subscription = getSubscription(dateToMonthYear(dayjs(startDate)))
  const { service, therapist } = usePaymentContext()

  const isSubscribedTherapistAndService = getIsSubscribedTherapistAndService(therapist, service, subscription)

  return (
    (subscription || activeSubscription) &&
    (isSubscribedTherapistAndService ||
      service.price === subscription?.initPrice ||
      service.price === activeSubscription?.initPrice)
  )
}
